import "./styles.scss";

import moment from "moment";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { VictoryBar, VictoryChart, VictoryAxis, VictoryTheme } from "victory";

// import { DateMonth } from "../../../utils/utils";
import { getPerformanceByAffiliateId, getPrivilegesRange } from "../../../store/middleware";

function Productivity({ setNavBar, setActiveTab }) {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const lang = localStorage.getItem("i18nextLng");
  const { user } = useSelector((state) => state.userReducer);
  const { affiliateAllPrivileges } = useSelector((state) => state.affiliateReducer);
  const { affiliateInfo, affiliateProductivity } = useSelector((state) => state.affiliateReducer);

  const [menu, setMenu] = useState(0);

  const level = affiliateProductivity?.currentSalesCount;
  const isManager = user?.role === "companyManager" || user?.role === "customerService";

  const graphicArray = [
    { id: 1, width: 10, height: 10, style: level >= affiliateAllPrivileges[0]?.range_min ? "circleActive" : "circle" },
    { id: 2, width: 5, height: 5, style: level >= 3 ? "circleActive" : "circle" },
    { id: 3, width: 5, height: 5, style: level >= 5 ? "circleActive" : "circle" },
    { id: 4, width: 5, height: 5, style: level >= 8 ? "circleActive" : "circle" },
    { id: 5, width: 10, height: 10, style: level >= affiliateAllPrivileges[1]?.range_min ? "circleActive" : "circle" },
    { id: 6, width: 5, height: 5, style: level >= 14 ? "circleActive" : "circle" },
    { id: 7, width: 5, height: 5, style: level >= 16 ? "circleActive" : "circle" },
    { id: 8, width: 5, height: 5, style: level >= 20 ? "circleActive" : "circle" },
    { id: 9, width: 10, height: 10, style: level >= affiliateAllPrivileges[2]?.range_min ? "circleActive" : "circle" },
    { id: 10, width: 5, height: 5, style: level >= 31 ? "circleActive" : "circle" },
    { id: 11, width: 5, height: 5, style: level >= 37 ? "circleActive" : "circle" },
    { id: 12, width: 5, height: 5, style: level >= 43 ? "circleActive" : "circle" },
    { id: 13, width: 10, height: 10, style: level >= affiliateAllPrivileges[3]?.range_min ? "circleActive" : "circle" },
    { id: 14, width: 5, height: 5, style: level >= 60 ? "circleActive" : "circle" },
    { id: 15, width: 5, height: 5, style: level >= 70 ? "circleActive" : "circle" },
    { id: 16, width: 5, height: 5, style: level >= 80 ? "circleActive" : "circle" },
    { id: 17, width: 10, height: 10, style: level >= affiliateAllPrivileges[4]?.range_min ? "circleActive" : "circle" },
  ];

  const totalDemoClass = affiliateProductivity?.countDemos?.reduce((acc, item) => acc + Number(item.qtd), 0);

  const formattedCommissionChart = affiliateProductivity?.comissionChart
    ?.filter((item) => item.month || item.year)
    ?.map((item) => ({
      x: moment(`${item.year}-${item.month}`, "YYYY-M").toDate(),
      y: parseFloat(item.totalValue),
    }));

  const formattedConversionChart = affiliateProductivity?.conversionChart?.map((item) => ({
    x: moment(`${item.year}-${item.month}`, "YYYY-M").toDate(),
    y: Number(item.count),
  }));

  const showGraphics = formattedCommissionChart?.length > 0 && formattedConversionChart?.length > 0;

  // const renderTranslateMonth = () => {
  //   const month = moment().format("MMMM");
  //   const year = moment().format("YYYY");

  //   return `${DateMonth[lang === "en" ? 0 : lang === "pt" ? 1 : lang === "es" ? 2 : 3][month]} ${year}`;
  // };

  const displayNumberToDecimal = (number = 0) => {
    const isEN = lang === "en" || lang === "en-US";
    return Number(number)
      .toFixed(2)
      .replace(".", isEN ? "." : ",");
  };

  const getData = async () => {
    dispatch(getPrivilegesRange());

    if (affiliateInfo) {
      await dispatch(getPerformanceByAffiliateId(affiliateInfo.id, affiliateInfo.createdAt));
    }
  };

  useEffect(() => {
    getData();
    // eslint-disable-next-line
  }, [affiliateInfo]);

  return (
    <div className="containerProductivity">
      <h2 className="title">{!isManager ? t("PRODUCTIVITY") : ""}</h2>

      <div className="cardProductivity">
        <div>
          <p className="textPrivileges">{t("PRIVILEGES")}</p>
          <p className="textStatus">{t(affiliateProductivity?.currentPrivilegeDescription?.toUpperCase())}</p>
        </div>

        <div className="contentGraphic">
          <div className="wrapperTitleGraphic">
            <p className="textGraphic bold">{t(affiliateAllPrivileges[0]?.description?.toUpperCase())}</p>
            <p className="textGraphic bold">{t(affiliateAllPrivileges[1]?.description?.toUpperCase())}</p>
            <p className="textGraphic bold">{t(affiliateAllPrivileges[2]?.description?.toUpperCase())}</p>
            <p className="textGraphic bold">{t(affiliateAllPrivileges[3]?.description?.toUpperCase())}</p>
            <p className="textGraphic bold">{t(affiliateAllPrivileges[4]?.description?.toUpperCase())}</p>
          </div>

          <div className="wrapperContentGraphic">
            {graphicArray.map((item, i) => (
              <div key={i} className={item.style} style={{ width: item.width, height: item.height }} />
            ))}
          </div>

          <div className="wrapperProgress">
            <p className="textGraphic white_500">00</p>
            <p className="textGraphic">{affiliateAllPrivileges[1]?.range_min}</p>
            <p className="textGraphic">{affiliateAllPrivileges[2]?.range_min}</p>
            <p className="textGraphic">{affiliateAllPrivileges[3]?.range_min}</p>
            <p className="textGraphic">{affiliateAllPrivileges[4]?.range_min}</p>
          </div>
        </div>

        <div>
          <p className="textSalesCounter">
            <span className="green_500 bold text_16">{affiliateProductivity?.currentSalesCount}</span> /{" "}
            <span className="bold">{affiliateProductivity?.currentPrivilegeRangeMax}</span> {t("SALES")}
          </p>
          <p className="textSalesCounter">
            {t("PRODUCTIVITYINFO1")} <span className="bold">{affiliateProductivity?.salesToNextPrivilege}</span>{" "}
            {t("PRODUCTIVITYINFO2")}{" "}
            <span className="bold">{t(affiliateProductivity?.nextPrivilegeDescription?.toUpperCase())}</span>
          </p>
        </div>

        {/* <div className="wrapperTotalCommission">
          <p className="textLabel">{t("TOTAL_LIFETIME_COMMISSION")}</p>
          <p className="valueCommission">$ {displayNumberToDecimal(affiliateProductivity?.totalComissionLifetime)}</p>
        </div> */}
      </div>

      <div className="wrapperInfoGraphic">
        <div className={`divLeft ${!showGraphics && "div_full"}`}>
          <div className="headerInfo">
            <p className="textHeaderInfo">
              {t("SALES1")}
              {/* {t("SALES1")} - <span>{renderTranslateMonth()}</span> */}
            </p>

            <button
              className="buttonHeaderInfo"
              onClick={() => (!isManager ? setNavBar(3) : setActiveTab("TRANSACTIONS"))}
            >
              {t("MY_TRANSACTIONS")}
            </button>
          </div>

          <div className="cardInfo">
            <p className="textLabel w_95">{t("MY_COMMISSION")}</p>
            <p className="textBalance">$ {displayNumberToDecimal(affiliateProductivity?.comissionValueSum)}</p>
            <div className="divMinimumWithdrawal">
              <p className="textMinimumWithdrawal">
                {t("MINIMUM_WITHDRAWAL1")} $50.00 {t("MINIMUM_WITHDRAWAL2")}
              </p>
            </div>
          </div>

          <div className="row">
            {/* <div className="cardInfo">
              <div>
                <p className="textLabel">{t("VISITS")}</p>
                <p className="textValue">25</p>
              </div>
            </div> */}

            <div className="cardInfo">
              <div>
                <p className="textLabel">{t("DEMOS")}</p>
                <p className="textValue">{totalDemoClass ?? 0}</p>
              </div>
            </div>

            <div className="cardInfo">
              <div>
                <p className="textLabel">{t("CONVERSIONS")}</p>
                <p className="textValue">{affiliateProductivity?.conversionsPeriod}</p>
              </div>
            </div>

            {affiliateProductivity?.currentSalesValueUSD !== "0.00" ||
            affiliateProductivity?.currentSalesValueBRL !== "0.00" ? (
              <>
                {affiliateProductivity?.currentSalesValueUSD !== "0.00" && (
                  <div className="cardInfo">
                    <div>
                      <p className="textLabel">{t("SALES1")}</p>
                      <p className="textValue">
                        $ {displayNumberToDecimal(affiliateProductivity?.currentSalesValueUSD)}
                      </p>
                    </div>
                  </div>
                )}

                {affiliateProductivity?.currentSalesValueBRL !== "0.00" && (
                  <div className="cardInfo">
                    <div>
                      <p className="textLabel">{t("SALES1")}</p>
                      <p className="textValue">
                        R$ {displayNumberToDecimal(affiliateProductivity?.currentSalesValueBRL)}
                      </p>
                    </div>
                  </div>
                )}
              </>
            ) : (
              <div className="cardInfo">
                <div>
                  <p className="textLabel">{t("SALES1")}</p>
                  <p className="textValue">$ {displayNumberToDecimal(0)}</p>
                </div>
              </div>
            )}
          </div>

          {affiliateProductivity?.salesByPlan?.length > 0 && (
            <div className="tableInfo">
              <div className="headerTable">
                <p className="labelHeaderTable">{t("FLAT")}</p>
                <p className="labelHeaderTable">{t("TOTAL")}</p>
              </div>

              {affiliateProductivity?.salesByPlan?.map((item, i) => (
                <div key={i} className={`bodyTable ${i % 2 === 0 && "gray_200"}`}>
                  <p className="itemTable">{item.nameEnglish}</p>
                  <p className="itemTable">{item.qtd}</p>
                </div>
              ))}
            </div>
          )}
        </div>

        {showGraphics && (
          <div className="divRight">
            <nav className="wrapperMenu">
              <button className={`itemMenu ${menu === 0 && "active"}`} onClick={() => setMenu(0)}>
                {t("COMMISSION")}
              </button>
              <button className={`itemMenu ${menu === 1 && "active"}`} onClick={() => setMenu(1)}>
                {t("CONVERSION")}
              </button>
            </nav>

            <div>
              <VictoryChart theme={VictoryTheme.material} domainPadding={{ x: 90 }} width={550}>
                <VictoryAxis tickFormat={(x) => moment(x && x).format("MMM YYYY")} />
                <VictoryAxis dependentAxis />
                <VictoryBar
                  x="x"
                  y="y"
                  data={menu === 0 ? formattedCommissionChart : formattedConversionChart}
                  labels={({ datum }) => (menu === 0 ? `$ ${displayNumberToDecimal(datum.y)}` : datum.y)}
                  style={{
                    data: { fill: menu === 0 ? "#00BA24" : "#22A0EE", width: 55 },
                    labels: { fontSize: 14, fontFamily: "Quicksand", fontWeight: "bold" },
                  }}
                />
              </VictoryChart>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default Productivity;
